<template>
    <div
        class="max-w-[900px] border-box w-full relative p-4 md:p-6"
        v-if="errorState.enabled">
        <div class="w-full border-box relative">
            <button
                @click="clearErrors"
                class="absolute top-3 z-10 right-3 fill-red-500 cursor-pointer">
                <svg
                    class="fill-inherit h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    aria-hidden="true"
                    focusable="false">
                    <path
                        class="fill-inherit"
                        d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                </svg>
            </button>
            <div
                class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
                role="alert">
                <div class="flex flex-row justify-start align-top">
                    <div class="w-4 mr-4 md:mr-6">
                        <Icon
                            icon="warning"
                            alt="warning" />
                    </div>
                    <div class="flex flex-col">
                        <div
                            v-if="errorState?.message"
                            class="copy"
                            v-html="errorState?.message"></div>
                        <button
                            v-if="errorState?.refresh_required"
                            @click="refreshAvailability"
                            class="font-bold mt-2 block text-left">
                            Click here to reselect
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { useErrorStore } from '@/stores/error';
    import { refreshAvailability } from '@/helpers/fetchData';

    const { clearErrors, state: errorState } = useErrorStore();
</script>
